import convertRetainToPoint from '../../utils/convertRetainToPoint';
import { TEMPORARY_BLOCK } from '../../../../types/BlockTypes';
export default function moveSelectionForward(editor, retain) {
  var _convertRetainToPoint = convertRetainToPoint(editor, retain),
      path = _convertRetainToPoint.path,
      offset = _convertRetainToPoint.offset,
      isLast = _convertRetainToPoint.isLast;

  editor.moveTo(path, offset);
  var inline = editor.value.document.getClosestInline(path);

  if (inline && offset === 0) {
    editor.moveToEndOfPreviousText();
  }

  if (isLast) {
    // Insert temporary padding block, to be able to put selection *after* last
    // block
    editor.insertBlock({
      type: TEMPORARY_BLOCK,
      nodes: [{
        object: 'text'
      }]
    });
  }

  return editor;
}